import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { inject } from '@angular/core';
import { parseDateOnly } from '../util';

export class CustomDateAdapter extends NativeDateAdapter {
  dateLocale = inject(MAT_DATE_LOCALE);

  // Valore del form control dal server: le colonne DATE arrivano come
  // "1980-05-15" (senza fuso). Il NativeDateAdapter le passerebbe a new Date()
  // = mezzanotte UTC, un giorno indietro a ovest di Greenwich: qui diventano
  // mezzanotte locale. Gli istanti ISO completi seguono la via standard.
  override deserialize(value: any): Date | null {
    return parseDateOnly(value) ?? super.deserialize(value);
  }

  override format(date: Date, displayFormat: any): string {
    if (displayFormat === 'input') {
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      if (this.dateLocale === 'it') {
        return `${day}/${month}/${year}`;
      } else {
        return `${month}/${day}/${year}`;
      }
    }
    return super.format(date, displayFormat);
  }
  override parse(value: any): Date | null {
    const dateOnly = parseDateOnly(value);
    if (dateOnly) return dateOnly;
    if (typeof value === 'string' && value.includes('/') && this.dateLocale === 'it') {
      const parts = value.split('/');
      const day = Number(parts[0]);
      const month = Number(parts[1]) - 1;
      const year = Number(parts[2]);
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        return new Date(year, month, day);
      }
    }
    return super.parse(value);
  }
}
